import { gql } from '@parkchirp/api-client';

export const CREATE_LEASING_RIGHT = gql`
    mutation createLeasingRight(
        $accountId: Int!,
        $lesseeEntity: String,
        $rightName: String!,
        $suites: String,
        $squareFeet: Int,
        $commencementDate: Date!,
        $expirationDate: Date!,
        $extensionOptions: String,
        $mustTakeRateId: String,
        $multipleRateMustTakeDollarAmount: Int,
        $leasingCountAndRates: [CreateLeasingCountAndRatesInputType]!,
        $buildings: [Int]
        $subtenants: [CreateLeasingRightSubtenantsInput!]!
    ) {
        createLeasingRight(
            accountId: $accountId,
            lesseeEntity: $lesseeEntity,
            rightName: $rightName,
            suites: $suites,
            squareFeet: $squareFeet,
            commencementDate: $commencementDate,
            expirationDate: $expirationDate,
            extensionOptions: $extensionOptions,
            mustTakeRateId: $mustTakeRateId,
            multipleRateMustTakeDollarAmount: $multipleRateMustTakeDollarAmount,
            leasingCountAndRates: $leasingCountAndRates,
            buildings: $buildings
            subtenants: $subtenants
        ) {
            id
        }
    }
`;

export const CREATE_CONVERSION_RIGHT = gql`
    mutation createConversionRight(
        $rateId: String!,
        $sublotId: Int!,
        $leasingCountAndRateId: Int!,
        $leasingConversionRightHistory: [CreateLeasingConversionRightHistoryInput]!,
        $leasingRightId: Int!
    ) {
        createConversionRight(
            rateId: $rateId,
            sublotId: $sublotId,
            leasingCountAndRateId: $leasingCountAndRateId,
            leasingConversionRightHistory: $leasingConversionRightHistory
            leasingRightId: $leasingRightId
        )
    }
`;

export const CREATE_LEASE_SUBTENANT = gql`
    mutation createLeaseSubtenant(
        $leasingRightId: Int!
        $accountId: String!
        $type: String!
    ) {
        createLeaseSubtenant(
            leasingRightId: $leasingRightId
            accountId: $accountId
            type: $type
        )
    }
`;

export const DELETE_COUNT_AND_RATE = gql`
    mutation deleteCountAndRate(
        $id: Int!
    ) {
        deleteCountAndRate(
            id: $id
        ) {
            leaseHasMoreCountAndRates
        }
    }
`;

export const DELETE_CONVERSION_RIGHT = gql`
    mutation deleteConversionRight(
        $id: Int!
        $leasingRightId: Int!
    ) {
        deleteConversionRight(
            id: $id
            leasingRightId: $leasingRightId
        )
    }
`;

export const DELETE_LEASE_SUBTENANT = gql`
    mutation deleteLeaseSubtenant(
        $id: Int!
        $leasingRightId: Int!
    ) {
        deleteLeaseSubtenant(
            id: $id
            leasingRightId: $leasingRightId
        )
    }
`;

export const CREATE_LEASING_COUNT_AND_RATES = gql`
    mutation createLeasingCountAndRates(
        $leasingRightId: Int!,
        $leasingCountAndRates: [CreateLeasingCountAndRatesInputType]!
    ) {
        createLeasingCountAndRates(
            leasingRightId: $leasingRightId,
            leasingCountAndRates: $leasingCountAndRates
        ) {
            id
        }
    }
`;

export const UPDATE_COUNT_AND_RATE = gql`
  mutation updateCountAndRate(
    $id: Int!
    $history: [UpdateCountAndRateHistoryInput!]!
    $leasingRightId: Int!
  ) {
    updateCountAndRate(
      id: $id
      history: $history
      leasingRightId: $leasingRightId
    )
  }
`;

export const UPDATE_LEASE_DETAILS = gql`
  mutation updateLeaseDetails(
    $id: Int!
    $rightName: String!
    $suites: String
    $squareFeet: Int
    $commencementDate: String!
    $expirationDate: String!
    $extensionOptions: String
    $buildings: [Int!]!
  ) {
    updateLeaseDetails(
      id: $id
      rightName: $rightName
      suites: $suites
      squareFeet: $squareFeet
      commencementDate: $commencementDate
      expirationDate: $expirationDate
      extensionOptions: $extensionOptions
      buildings: $buildings
    )
  }
`;

export const UPDATE_CONVERSION_RIGHT = gql`
    mutation updateConversionRight(
        $id: Int!,
        $leasingCountAndRateId: Int!,
        $leasingConversionRightHistory: [UpdateLeasingConversionRightHistoryInput]!,
        $leasingRightId: Int!
    ) {
        updateConversionRight(
            id: $id,
            leasingCountAndRateId: $leasingCountAndRateId,
            leasingConversionRightHistory: $leasingConversionRightHistory,
            leasingRightId: $leasingRightId
        )
    }
`;

export const CREATE_SEQUENCING_TIER = gql`
    mutation createSequencingTier(
        $subscriptionId: String!
        $rateId: String!
        $sublotId: Int!
        $tierNumber: Int!
        $setNumber: Int!
        $leasingCountAndRateId: Int
        $leasingConversionRightId: Int
    ) {
        createSequencingTier(
            subscriptionId: $subscriptionId,
            rateId: $rateId,
            sublotId: $sublotId,
            tierNumber: $tierNumber
            setNumber: $setNumber
            leasingCountAndRateId: $leasingCountAndRateId
            leasingConversionRightId: $leasingConversionRightId
        ) {
            id
        }
    }
`;

export const DELETE_CONTRACT_DOCUMENT = gql`
    mutation deleteContractDocument(
        $id: Int!
    ) {
        deleteContractDocument(
            id: $id
        )
    }
`;

export const CREATE_CONTRACT_DOCUMENT = gql`
    mutation createContractDocument(
        $accountId: String!,
        $contractDate: Date!,
        $subscriberType: SubscriberTypeEnum!,
        $contractType: ContractTypeEnum!,
        $landlordEntity: String,
        $subscriberEntity: String,
        $commencementDate: Date,
        $expirationDate: Date,
        $parkingContractSection: String,
        $documentContentType: String,
        $documentPath: String,
    ) {
        createContractDocument(
            accountId: $accountId,
            contractDate: $contractDate,
            subscriberType: $subscriberType,
            contractType: $contractType,
            landlordEntity: $landlordEntity,
            subscriberEntity: $subscriberEntity,
            commencementDate: $commencementDate,
            expirationDate: $expirationDate,
            parkingContractSection: $parkingContractSection,
            documentContentType: $documentContentType,
            documentPath: $documentPath,
        ) {
            id
        }
    }
`;

export const UPDATE_CONTRACT_DOCUMENT = gql`
    mutation updateContractDocument(
        $id: Int!,
        $contractDate: Date,
        $subscriberType: SubscriberTypeEnum,
        $contractType: ContractTypeEnum,
        $landlordEntity: String,
        $subscriberEntity: String,
        $commencementDate: Date,
        $expirationDate: Date,
        $parkingContractSection: String,
        $documentContentType: String,
        $documentPath: String,
    ) {
        updateContractDocument(
            id: $id,
            contractDate: $contractDate,
            subscriberType: $subscriberType,
            contractType: $contractType,
            landlordEntity: $landlordEntity,
            subscriberEntity: $subscriberEntity,
            commencementDate: $commencementDate,
            expirationDate: $expirationDate,
            parkingContractSection: $parkingContractSection,
            documentContentType: $documentContentType,
            documentPath: $documentPath,
        )
    }
`;

export const UPDATE_LEASE_MANAGER_SETTINGS = gql`
    mutation updateLeaseManagerSettings(
        $accountId: Int!,
        $abstract: String,
    ) {
        updateLeaseManagerSettings(
            accountId: $accountId,
            abstract: $abstract,
        )
    }
`;

export const UPDATE_PARKER_SEQUENCE_NUMBER = gql`
    mutation updateParkerSequenceNumber(
        $parkerId: String!
        $sequenceNumber: Int!
        $sequenceNumberLocked: Boolean!
    ) {
        updateParkerSequenceNumber(
            parkerId: $parkerId
            sequenceNumber: $sequenceNumber
            sequenceNumberLocked: $sequenceNumberLocked
        )
    }
`;

export const DELETE_SEQUENCING_TIER = gql`
    mutation deleteSequencingTier(
        $id: Int!
    ) {
        deleteSequencingTier(
            id: $id
        )
    }
`;

export const UPDATE_TIER_NUMBERS = gql`
    mutation updateTierNumbers(
        $subscriptionId: String!
        $tiers: [UpdateTierNumbersInput!]!
    ) {
        updateTierNumbers(
            subscriptionId: $subscriptionId
            tiers: $tiers
        )
    }
`;

export const INSERT_PARKERS_IN_SEQUENCE = gql`
    mutation insertParkersInSequence(
        $subscriptionId: String!
        $parkerIds: [String!]!
        $sequenceNumber: Int!
    ) {
        insertParkersInSequence(
            subscriptionId: $subscriptionId
            parkerIds: $parkerIds
            sequenceNumber: $sequenceNumber
        )
    }
`;

export const BULK_LOCK_OR_UNLOCK_PARKERS = gql`
    mutation bulkLockOrUnlockParkers(
        $subscriptionId: String!
        $setNumber: Int!
        $isLocked: Boolean!
    ) {
        bulkLockOrUnlockParkers(
            subscriptionId: $subscriptionId
            setNumber: $setNumber
            isLocked: $isLocked
        )
    }
`;
